import { render, staticRenderFns } from "./ResendActivation.vue?vue&type=template&id=4a968734&"
import script from "./ResendActivation.vue?vue&type=script&lang=js&"
export * from "./ResendActivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports